import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  salesInvoiceEditAction,
  salesInvoiceReceiptCreateAction,
} from "../../../redux/actions/sales-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import SalesPurchaseFooter from "../sales-purchase-footer";
import SalesPurchaseNavbar from "../sales-purchase-navbar";
import SalesItemsSection from "../sales-items-sec";
import SalesBatchesPanel from "../sales-batches-panel";
const CreateEditViewSalesInv = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  type = "",
  page = "",
  disabled = false,
  data,
  standAlone = false,
  itemData,
  payto,
  shipto,
  pageType,
  clickedplus,
  auto = false,
}) => {
  const [heading, setHeading] = useState([]);

  const [buttonLoading, setButtonLoading] = useState(false);
  const searchRef = useRef(null);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");

  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const initialData = {
    sl_no: 1,
    item_code: "",
    item_generic_name: "",
    item_name: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_to_be_delivered: 0,
    quantity: 0,
    item_free_quantity: 0,
    item_batches: [],
    item_discount_amount: 0.0,
    item_total_tax_percentage: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    instock: true,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_uom_id: "",
    item_manufacturer_id: "",
    pot_id: null,
    pos_id: null,
    base_quantity: 1,
  };

  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    remarks: vendorDetails?.[0]?.remarks ?? "",

    ...(vendorDetails?.[0]?.soit_id
      ? { soit_id: vendorDetails?.[0]?.soit_id }
      : {}),
    soit_order_date: vendorDetails?.[0]?.soit_order_date
      ? moment(vendorDetails?.[0]?.soit_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    soit_document_date: vendorDetails?.[0]?.soit_document_date
      ? moment(vendorDetails?.[0]?.soit_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    soit_delivery_date: vendorDetails?.[0]?.soit_delivery_date
      ? moment(vendorDetails?.[0]?.soit_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    // pot_id: vendorDetails?.[0]?.pot_id ?? null,
    // pos_id: vendorDetails?.[0]?.pos_id ?? null,
    pot_id: itemData?.pot_id ?? null, //update
    pos_id: itemData?.pos_id ?? null, //update

    soit_sub_total: isClone ? 0 : vendorDetails?.[0]?.soit_sub_total || "0.00",
    soit_total_discount: isClone
      ? 0
      : vendorDetails?.[0]?.soit_total_discount ?? 0,
    soit_total_gst: isClone ? 0 : vendorDetails?.[0]?.soit_total_gst || "0.00",
    soit_round_off_value: isClone
      ? 0
      : vendorDetails?.[0]?.soit_round_off_value || "0.00",
    soit_total_amount: isClone
      ? 0
      : vendorDetails?.[0]?.soit_total_amount || "0.00",
    cmr_tcs: "",
    cmr_tds: "",
    soit_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    soit_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage ?? 0,
    soit_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    soit_tcs_or_tds_amount: vendorDetails?.[0]?.tcs_or_tds_amount ?? 0,
    soit_order_status: vendorDetails?.[0]?.soit_order_status ?? "",
    soit_pay_to_address: payto || null, //new
    soit_ship_to_address: shipto || null, //new

    // customer_invoice_number: vendorDetails?.[0]?.customer_invoice_number ?? null,
    soit_is_invoice_dis_percentage:
      vendorDetails?.[0]?.soit_is_invoice_dis_percentage ?? true,
    soit_invoice_discount: vendorDetails?.[0]?.soit_invoice_discount ?? 0,
    soit_invoice_discount_percentage:
      vendorDetails?.[0]?.soit_invoice_discount_percentage ?? 0,
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.soit_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.soit_invoice_discount_percentage
      : vendorDetails?.[0]?.soit_invoice_discount,

    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_uom: item?.item_uom ?? "--",
        item_to_be_delivered: item?.item_to_be_delivered ?? 0,
        quantity:
          type === "sales"
            ? 0
            : item?.item_to_be_delivered ?? item?.item_quantity,
        item_free_quantity:
          type === "sales" ? 0 : parseInt(item?.item_free_quantity),
        // quantity: type === "sales" ? 0 : item?.item_quantity,
        item_batches:
          type === "sales" || isClone
            ? []
            : item?.itemBatchData?.map((batch) => ({
                item_batch_number: batch?.item_batch_number ?? 0,
                item_batch_quantity: parseInt(batch?.item_batch_quantity) || 0,
                item_batch_free_quantity:
                  parseInt(batch?.item_batch_free_quantity) || 0,
                item_batch_sales_rate:
                  parseFloat(batch?.item_batch_sales_rate) || 0,
                item_batch_total_base_sales_rate:
                  parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                item_batch_discount_percentage:
                  parseFloat(batch?.item_batch_discount_percentage) || 0,
                item_batch_discount_amount:
                  parseFloat(batch?.item_batch_discount_amount) || 0,
                item_batch_discounted_sales_rate:
                  parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                item_batch_tax_percentage:
                  parseFloat(batch?.item_batch_tax_percentage) || 0,
                item_batch_tax_amount:
                  parseFloat(batch?.item_batch_tax_amount) || 0,
                item_batch_final_sales_rate:
                  parseFloat(batch?.item_batch_final_sales_rate) || 0,
                item_batch_total_sales_rate:
                  parseFloat(batch?.item_batch_total_sales_rate) || 0,
                item_batch_sgst:
                  parseFloat(batch?.item_batch_tax_amount) / 2 || 0,
                item_batch_cgst:
                  parseFloat(batch?.item_batch_tax_amount) / 2 || 0,
                item_batch_unit_price:
                  parseFloat(batch?.item_batch_unit_price) || 0,
                item_exp_date: batch?.item_exp_date
                  ? moment(batch?.item_exp_date).format("YYYY-MM-DD")
                  : "1970-01-01", // Default to a date if not provided
                item_id: batch?.item_id ?? 0,
                from_bin_location: batch?.from_bin_location ?? "",
                from_bin_id: batch?.from_bin_id ?? 0,
                item_batch_avail_quantity: parseInt(batch?.item_batch_quantity),
              })) ?? [],
        item_discount_amount:
          type === "sales" || isClone ? 0 : item?.item_discount_amount,
        item_total_tax_percentage:
          type === "sales" || isClone ? 0 : item?.item_total_tax_percentage,
        item_tax_amount:
          type === "sales" || isClone ? 0 : item?.item_tax_amount ?? 0,
        item_total_amount:
          type === "sales" || isClone ? 0 : item?.item_total_amount,
        item_id: item?.item_id,
        sott_id: item?.sott_id,
        sodtt_id: item?.sodtt_id,
        instock: true,
        item_gst: item?.item_gst,
        item_cgst: item?.item_cgst,
        item_sgst: item?.item_sgst,
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              base_quantity: uom?.base_quantity ?? 1,

              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
            }))
          : [],
        item_uom_id: item?.item_uom_id ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
        base_quantity: item?.base_quantity ?? 1,
      })),
      initialData,
      // ...(type === "sales" || type === "invoice"
      //   ? [{ ...initialData }]
      //   : []),
    ],
  };

  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const salesData = parsed.find((obj) => obj?.sales_invoice_create);
      if (salesData?.sales_invoice_create) {
        setHeading(salesData.sales_invoice_create);
      }
    }
  }, []);
  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};

  const handleSubmit = (values, actions) => {
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.soit_order_status !== "draft"
    ) {
      setButtonLoading(true);

      dispatch(
        salesInvoiceEditAction(
          {
            is_draft_order: values.submittedButton === "draft" ? true : false,
            only_remarks: true,
            soit_id: values?.soit_id,
            remarks: values?.remarks,
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast(
          "Please add UOM for all items" && values?.submittedButton !== "draft"
        );
      } else {
        if (values?.data?.length > 0) {
          setButtonLoading(true);

          dispatch(
            salesInvoiceReceiptCreateAction(
              {
                orderData: {
                  is_draft_order:
                    values.submittedButton === "draft" ? true : false,
                  store_id: storeId,
                  ...(values?.soit ? { soit: values?.soit } : {}),
                  soit_total_gst: values?.soit_total_gst,
                  soit_total_discount: values?.soit_total_discount,
                  soit_payment_status: "paid",
                  soit_transaction_id: "",
                  soit_billing_address: "",
                  soit_total_amount: values?.soit_total_amount,
                  soit_sub_total: values?.soit_sub_total,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  soit_order_date: values?.soit_order_date,
                  soit_document_date: values?.soit_document_date,
                  soit_delivery_date: values?.soit_delivery_date,
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? null,
                  soit_round_off_value: values?.soit_round_off_value,

                  soit_tcs_or_tds_percentage_id:
                    values?.soit_tcs_or_tds_percentage_id ?? "",
                  soit_tcs_or_tds_percentage:
                    Number(values?.soit_tcs_or_tds_percentage) ?? 0,
                  soit_tds_tcs_type: values?.soit_tds_tcs_type ?? "",
                  soit_tcs_or_tds_amount: values?.soit_tcs_or_tds_amount ?? 0,
                  // customer_invoice_number: values?.customer_invoice_number, // not accepting in backend
                  soit_is_invoice_dis_percentage: Number(
                    values?.soit_is_invoice_dis_percentage
                  ),
                  soit_invoice_discount: Number(values?.soit_invoice_discount),
                  soit_invoice_discount_percentage: Number(
                    values?.soit_invoice_discount_percentage
                  ),
                  soit_pay_to_address: values?.soit_pay_to_address || null, //new
                  soit_ship_to_address: values?.soit_ship_to_address || null, //new
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_quantity: parseInt(item?.quantity),
                  item_free_quantity: parseInt(item?.item_free_quantity ?? 0),
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_discount_amount: parseFloat(item?.item_discount_amount),
                  item_total_tax_percentage: item?.item_total_tax_percentage,
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_id: item?.item_id,
                  ...(item?.sott_id && type === "sales"
                    ? { sott_id: item?.sott_id }
                    : { sott_id: null }),
                  ...(item?.sodtt_id && type === "delivery"
                    ? { sodtt_id: item?.sodtt_id }
                    : { sodtt_id: null }),
                  item_gst: parseFloat(item?.item_gst),
                  item_sgst: parseFloat(item?.item_sgst),
                  item_cgst: parseFloat(item?.item_cgst),
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? null,
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_batch_quantity: parseInt(batch?.item_batch_quantity),
                    item_batch_free_quantity: parseInt(
                      batch?.item_batch_free_quantity
                    ),
                    item_batch_sales_rate: parseFloat(
                      batch?.item_batch_sales_rate
                    ),
                    item_batch_total_base_sales_rate:
                      parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                    item_batch_discount_percentage:
                      batch?.item_batch_discount_percentage,
                    item_batch_discount_amount: parseFloat(
                      batch?.item_batch_discount_amount
                    ),
                    item_batch_discounted_sales_rate:
                      parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                    item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: parseFloat(
                      batch?.item_batch_tax_amount
                    ),
                    item_batch_final_sales_rate: parseFloat(
                      batch?.item_batch_final_sales_rate
                    ),
                    item_batch_total_sales_rate: parseFloat(
                      batch?.item_batch_total_sales_rate
                    ),
                    item_batch_unit_price: parseFloat(
                      batch?.item_batch_unit_price
                    ),
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                  })),
              },
              onSuccessOrder,
              onErrorOrder
            )
          );
        }
      }
    }
  };

  const onSuccessOrder = (data) => {
    setButtonLoading(false);

    if (formValues?.submittedButton === "print") {
      handlea4Print(data?.data?.orderData?.soit_id, "sales_invoice", dispatch);
    }
    navigate("/sales-invoice");
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_id: "",
      remarks: "",
      soit_total_discount: 0,
      soit_order_date: null,
      soit_document_date: null,
      soit_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = () => {
    errorToast(data?.data?.message);
    setButtonLoading(false);
  };

  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  const autoDraft = (values) => {
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.soit_order_status !== "draft"
    ) {
      setButtonLoading(true);

      dispatch(
        salesInvoiceEditAction(
          {
            is_draft_order: values.submittedButton === "draft" ? true : false,
            only_remarks: true,
            soit_id: values?.soit_id,
            remarks: values?.remarks,
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast(
          "Please add UOM for all items" && values?.submittedButton !== "draft"
        );
      } else {
        if (values?.data?.length > 0) {
          setButtonLoading(true);

          dispatch(
            salesInvoiceReceiptCreateAction(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: storeId,
                  ...(values?.soit ? { soit: values?.soit } : {}),
                  soit_total_gst: values?.soit_total_gst,
                  soit_total_discount: values?.soit_total_discount,
                  soit_payment_status: "paid",
                  soit_transaction_id: "",
                  soit_billing_address: "",
                  soit_total_amount: values?.soit_total_amount,
                  soit_sub_total: values?.soit_sub_total,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  soit_order_date: values?.soit_order_date,
                  soit_document_date: values?.soit_document_date,
                  soit_delivery_date: values?.soit_delivery_date,
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? null,
                  soit_round_off_value: values?.soit_round_off_value,

                  soit_tcs_or_tds_percentage_id:
                    values?.soit_tcs_or_tds_percentage_id ?? "",
                  soit_tcs_or_tds_percentage:
                    Number(values?.soit_tcs_or_tds_percentage) ?? 0,
                  soit_tds_tcs_type: values?.soit_tds_tcs_type ?? "",
                  soit_tcs_or_tds_amount: values?.soit_tcs_or_tds_amount ?? 0,
                  // customer_invoice_number: values?.customer_invoice_number, // not accepting in backend
                  soit_is_invoice_dis_percentage: Number(
                    values?.soit_is_invoice_dis_percentage
                  ),
                  soit_invoice_discount: Number(values?.soit_invoice_discount),
                  soit_invoice_discount_percentage: Number(
                    values?.soit_invoice_discount_percentage
                  ),
                  soit_pay_to_address: values?.soit_pay_to_address || null, //new
                  soit_ship_to_address: values?.soit_ship_to_address || null, //new
                },
                itemData: values.data?.slice(0, -1).map((item, index) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_quantity: parseInt(item?.quantity),
                  item_free_quantity: parseInt(item?.item_free_quantity ?? 0),
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  // item_unit_price: parseFloat(item?.item_unit_price),
                  item_discount_amount: parseFloat(item?.item_discount_amount),
                  item_total_tax_percentage: item?.item_total_tax_percentage,
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_total_amount: parseFloat(item.item_total_amount),
                  item_id: item?.item_id,
                  ...(item?.sott_id && type === "sales"
                    ? { sott_id: item?.sott_id }
                    : { sott_id: null }),
                  ...(item?.sodtt_id && type === "delivery"
                    ? { sodtt_id: item?.sodtt_id }
                    : { sodtt_id: null }),
                  item_gst: parseFloat(item?.item_gst),
                  item_sgst: parseFloat(item?.item_sgst),
                  item_cgst: parseFloat(item?.item_cgst),
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? null,
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_batch_quantity: parseInt(batch?.item_batch_quantity),
                    item_batch_free_quantity: parseInt(
                      batch?.item_batch_free_quantity
                    ),
                    item_batch_sales_rate: parseFloat(
                      batch?.item_batch_sales_rate
                    ),
                    item_batch_total_base_sales_rate:
                      parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                    item_batch_discount_percentage:
                      batch?.item_batch_discount_percentage,
                    item_batch_discount_amount: parseFloat(
                      batch?.item_batch_discount_amount
                    ),
                    item_batch_discounted_sales_rate:
                      parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                    item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                    item_batch_tax_amount: parseFloat(
                      batch?.item_batch_tax_amount
                    ),
                    item_batch_final_sales_rate: parseFloat(
                      batch?.item_batch_final_sales_rate
                    ),
                    item_batch_total_sales_rate: parseFloat(
                      batch?.item_batch_total_sales_rate
                    ),
                    item_batch_unit_price: parseFloat(
                      batch?.item_batch_unit_price
                    ),
                    item_exp_date: batch?.item_exp_date,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                  })),
              },
              (data) => {
                successToast(data?.message);
                // setLoading(true);
                setTimeout(() => {
                  // setLoading(false);
                }, 50);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-sales-invoice/${data?.data?.orderData?.soit_id}?new`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                errorToast(data?.data?.message);
              }
            )
          );
        }
      }
    }
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        setTimeout(() => {
          handleSubmit(values, actions); // Pass values and actions if needed
          actions.setSubmitting(false); // Notify Formik that submission is done
        }, 500);
      }}
    >
      {({ values, setFieldValue, errors }) => {
        setFormValues(values);
        return (
          <Form className="h-full">
            <div
              style={{
                height: `calc(100% - 8rem)`,
              }}
              className="mx-5 flex flex-col h-full "
            >
              <SalesBatchesPanel
                searchRef={searchRef}
                open={addbatch}
                setOpen={setAddbatch}
                disabled={disabled}
                setItemId={setItemId}
                itemId={itemId}
                itemValues={values}
                prefix="soit"
              />
              <SalesPurchaseNavbar
                isClone={isClone}
                autoDraft={autoDraft}
                clickedplus={clickedplus}
                pageType={pageType}
                page={page}
                isCusInvNumRequired={false}
                section="sales"
                name="soit"
                disabled={disabled}
                searchRef={searchRef}
              />

              <SalesItemsSection
                auto={auto}
                heading={heading}
                standAlone={standAlone}
                disName="soit_total_discount"
                type={type}
                disabled={disabled}
                addBatchFn={(id) => {
                  setAddbatch(true);
                  setItemId(id);
                }}
                searchRef={searchRef}
                initialData={initialData}
                prefixName={"soit"}
              />
            </div>
            <SalesPurchaseFooter
              modules="sales"
              EditFn={() => {
                navigate(`/edit-sales-invoice/${values?.soit_id}`);
              }}
              transaction="Sales Invoice"
              transaction_type="sales_invoice"
              buttonLoading={buttonLoading}
              name="soit_total_discount"
              page={page}
              disabled={disabled}
              prefixName="soit"
              tcsTdsAmount={tcsTdsAmount}
              setTcsTdsAmount={setTcsTdsAmount}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEditViewSalesInv;
